import { LayoutComponent } from "../../../components";
import { Outlet } from "react-router-dom";

export const CatalogLayout = () => {
  return (
    <LayoutComponent selectedMenuItem={"catalog"}>
      <Outlet />
    </LayoutComponent>
  );
};
